import Organization from "../Organization";

class OrganizationBuilder {
  static buildOrganization(
    id,
    abbrev,
    addresses,
    description,
    image,
    name,
    website
  ) {
    if (
      id == null ||
      abbrev == null ||
      addresses == null ||
      description == null ||
      image == null ||
      name == null ||
      website == null
    ) {
      return null;
    }

    if (
      typeof id !== "string" ||
      typeof abbrev !== "string" ||
      typeof addresses !== "string" ||
      typeof description !== "string" ||
      typeof image !== "string" ||
      typeof name !== "string" ||
      typeof website !== "string"
    ) {
      return null;
    }

    return new Organization(
      id,
      abbrev,
      addresses,
      description,
      image,
      name,
      website
    );
  }

  static buildOrgArrWithValueLabelPairs(orgs) {
    if (orgs == null) {
      return null;
    }

    const result = [];
    orgs.forEach((org) => {
      const pair = {};
      pair["value"] = org;
      pair["label"] = org.name;
      result.push(pair);
    });

    return result;
  }
}

export default OrganizationBuilder;
